<template>
  <div>
    <div class="mdgridviewpage-bg homenewbgdata">
      <training-header></training-header>

      <div
        class="container-fluid m-t-10px d-flex"
        style="height: calc(100vh - 146px);"
      >
        <div class="dashboardchart-container globalconfigcontainer">
          <div class="formDiv h-100" style>
            <div class="card h-100 cardDiv">
              <div
                class="collapse show"
                aria-labelledby="headingOne"
                style="width: 55%;margin: auto;">
                <ValidationObserver v-slot="{ handleSubmit }">
                  <div class="card-body c-body">
                    <form class="" @submit.prevent="handleSubmit(onSubmit)">
                      <div class="">
                        <h4
                          class="inner-heading text-center pt-2 pb-1 w-100 mb-4"
                          style="font-weight: 400; margin-bottom:0px;color:#fff"
                        >
                          <i
                            class="fa fa-user mr-2 text-white"
                            aria-hidden="true"
                          ></i>
                          Sign In
                        </h4>
                        <div class="mainform-holder w-100">
                          <div class="col-lg-12 mb-2">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <ValidationProvider
                                  name="E-mail"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="email"
                                    type="text"
                                    class="form-control bg-grey"
                                    id="inputContactEmail"
                                    placeholder="Username"
                                  />
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-3">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <ValidationProvider
                                  name="Password"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <div class="input-group">
                                    <input
                                      v-model="password"
                                      type="password"
                                      class="form-control bg-grey"
                                      id="inputContactEmailPassword"
                                      placeholder="Password"
                                    />
                                    <div class="input-group-append">
                                      <span
                                        @click="showPass"
                                        class="input-group-text fa fa-eye bg-grey"
                                      ></span>
                                    </div>
                                  </div>
                                  <span class="text-danger">{{
                                    errors[0]
                                  }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-3">
                            <div class="row mb-4">
                              <div class="col-12">
                                <div class="form-group row mb-0">
                                  <div class="col-sm-12 text-left">
                                    <button
                                      type="submit"
                                      class="btn btn-primary black-btn btn-block text-white"
                                      style="padding: 6px 35px; border-radius:50px; background-color: #5e5eb7"
                                    >
                                      Sign In
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 mb-2">
                                <div class="form-group">
                                  <a
                                    class="d-flex justify-content-center text-white"
                                    @click="
                                      $bvModal.show('forgotPasswordModal')
                                    "
                                    style="font-size: 14px;"
                                    >Forgot Password ?</a
                                  >
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="form-group row mb-0">
                                  <div
                                    class="col-sm-12 text-center"
                                    style="border-right: 1px solid #797979;"
                                  >
                                    <!-- <a
                                              class="btn btn-primary black-btn color-white"
                                              @click="GotoCreateAccount()"
                                    >Create an Account</a>-->
                                    <a
                                      class="text-white"
                                      @click="GotoCreateAccount()"
                                      style="font-size:14px"
                                      >Register Now</a
                                    >
                                  </div>
                                </div>
                              </div>

                              <div class="col-6">
                                <div class="form-group row mb-0">
                                  <div class="col-sm-12 text-center">
                                    <a
                                      class="text-white"
                                      @click="goToActivateAccount"
                                      style="font-size: 14px;"
                                      >Activate Account</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
        <div class="h-100">
          <img src="../assets/img/vizi-graphic.png" class="h-100 w-100" style />
        </div>
      </div>
      <training-footer></training-footer>
    </div>

    <b-modal id="forgotPasswordModal" centered>
      <template v-slot:modal-title>Forgot Password</template>
      <template v-slot:default>
        <ValidationObserver ref="frmForgotPassword">
          <div class="col-lg-12">
            <div class="form-group row">
              <!-- <label class="col-sm-3 col-form-label">* E-mail</label> -->
              <div class="col-sm-12">
                <ValidationProvider
                  name="Email"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    v-model="forgotEmail"
                    type="email"
                    class="form-control"
                    placeholder="Enter Email"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </template>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('forgotPasswordModal')"
        >
          Close
        </button>
        <button type="button" class="btn btn-primary" @click="forgotPassword()">
          Save
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import ApiServices from "../service/ApiServices";
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";

extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  name: "home",
  props: {},
  components: {
    trainingHeader,
    trainingFooter,
  },
  data() {
    return {
      email: "",
      password: "",
      forgotEmail: "",
      settings: settings,
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/Avenir_Generic/index.html#/",
    };
  },
  methods: {
    showPass() {
      let passwordField = document.querySelector("#inputContactEmailPassword");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    GotoCreateAccount() {
      this.$router.push("/create-account");
    },
    goToActivateAccount() {
      this.$router.push("/activate");
    },
    onSubmit() {
      this.$root.loading = true;
      this.baseUrl = ApiServices.getBaseUrl();
      this.dashboardUrl = this.baseUrl + this.dashboardUrl;
      //let headers = {Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='};
      let authorizationToken =
        "Basic " + btoa(this.email + ":" + this.password);
      localStorage.setItem("authToken", authorizationToken);
      ApiServices.RestPostCall("api/avenir/login", {
        username: this.email,
        password: this.password,
      })
        .then((res) => {
          console.log(res);
          this.$root.loading = false;
          if (res.status.toLocaleLowerCase() == "success") {
            localStorage.setItem("userProfile", JSON.stringify(res));
            localStorage.setItem("loggedInUserId", res.useruid);
            //console.log(JSON.parse(localStorage.getItem("userProfile")));
            //this.$router.push("/wizard");
            if (settings.countryName.toLowerCase() === "nepal") {
              if (settings.userRole.includes(res.userrole)) {
                this.$router.push("/select-plan-nepal");
              } else {
                window.open(this.dashboardUrl, "_blank");
              }
            } else {
              // this.$router.push("/select-plan");
              this.$router.push("/applicationList");
            }
          } else {
            this.$swal({
              icon: "error",
              text: res.message,
            });
            // logout forcefully
            ApiServices.RestGetCall(
              "dhis-web-commons-security/logout.action",
              {}
            ).then((res) => {
              console.log(res);
            });
          }
        })
        .catch((error) => {
          this.$root.loading = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            //console.log(error.response.headers);
            this.$swal({
              text: "incorrect username/password",
            });
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          // logout forcefully
          ApiServices.RestGetCall(
            "dhis-web-commons-security/logout.action",
            {}
          ).then((res) => {
            console.log(res);
          });
          //console.log(error.config);
        });
    },
    forgotPassword() {
      if (this.$refs.frmForgotPassword.validate()) {
        this.$root.loading = true;
        console.log(this.forgotEmail);
        //this.forgotEmail = "";
        ApiServices.RestPostCall("api/avenir/subscribe/password/forgot", {
          email: this.forgotEmail,
        }).then((res) => {
          console.log(res);
          this.$swal({
            text: res.message,
          });
          this.$bvModal.hide("forgotPasswordModal");
          this.$root.loading = false;
        });
        //this.$bvModal.hide('forgotPasswordModal')
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
